/**
 * CRM Multi-Compagnia · Lista Insoluti (con gravità colore)
 */
import { useState } from "react";
import { AlertTriangle, Send } from "lucide-react";
import {
  api, useApi, DataTable, Spinner, ErrorBox, Btn, Select, toast, fmtDate, fmtEUR
} from "@/components/crm-multi/shared";

export default function CrmMultiInsolutiPage() {
  const [stato, setStato] = useState("aperto");
  const list = useApi(() => api.get("/unpaid", { stato: stato || undefined, limit: 200 }), [stato]);

  const sendSollecito = () => toast("Sollecito inviato (MOCK — integrazione Spoki/Email Fase 5)", "info");

  const giorniDa = (iso) => Math.floor((Date.now() - new Date(iso).getTime()) / (1000 * 60 * 60 * 24));
  const gravita = (gg) => gg < 15 ? "bg-amber-100 text-amber-800" : gg < 45 ? "bg-orange-100 text-orange-800" : "bg-rose-100 text-rose-800";

  return (
    <div className="space-y-4" data-testid="cm-insoluti-page">
      <header className="flex justify-between items-center gap-3">
        <div>
          <h2 className="text-lg font-semibold flex items-center gap-2"><AlertTriangle className="w-5 h-5 text-rose-600" /> Insoluti</h2>
          <p className="text-sm text-zinc-500">{list.data?.total ?? 0} insoluti</p>
        </div>
        <Select value={stato} onChange={(e) => setStato(e.target.value)} className="md:w-56">
          <option value="">Tutti</option>
          <option value="aperto">Aperti</option>
          <option value="in_recupero">In recupero</option>
          <option value="recuperato">Recuperati</option>
          <option value="perso">Persi</option>
        </Select>
      </header>

      <ErrorBox error={list.error} />
      {list.loading ? <Spinner /> : (
        <DataTable
          testid="cm-insoluti-table"
          columns={[
            { key: "data_insoluto", label: "Data insoluto", render: r => fmtDate(r.data_insoluto) },
            { key: "gravita", label: "Gg.", render: r => {
              const gg = giorniDa(r.data_insoluto);
              return <span className={`px-2 py-0.5 rounded text-xs font-medium ${gravita(gg)}`}>{gg} gg</span>;
            }},
            { key: "policy_id", label: "Polizza", render: r => <code className="text-xs">{r.policy_id?.slice(0, 8)}</code> },
            { key: "importo_eur", label: "Importo", render: r => <span className="font-mono text-sm">{fmtEUR(r.importo_eur)}</span> },
            { key: "motivo", label: "Motivo", render: r => <span className="text-xs">{r.motivo || "—"}</span> },
            { key: "stato", label: "Stato", render: r => <span className="text-xs capitalize">{r.stato}</span> },
            { key: "az", label: "", render: r => r.stato === "aperto" && <Btn size="sm" variant="ghost" onClick={sendSollecito}><Send className="w-3.5 h-3.5" /> Sollecito</Btn> },
          ]}
          rows={list.data?.items || []}
          emptyTitle="Nessun insoluto"
        />
      )}
    </div>
  );
}
